const defaultUser = {
  email: 'sandra@example.com',
  avatarUrl: 'https://js.devexpress.com/Demos/WidgetsGallery/JSDemos/images/employees/06.png'
};
export default {
  _user: defaultUser,
  loggedIn() {
    return !!this._user;
  },

  async logIn(email, password) {
    try {
      // Send request
      this._user = { ...defaultUser, email };

      //数据持久化
      localStorage.setItem("storageUser",JSON.stringify(this._user))

      return {
        isOk: true,
        data: this._user
      };
    }
    catch {
      return {
        isOk: false,
        message: "登录失败"
      };
    }
  },

  async logOut() {
      localStorage.removeItem("storageUser")
      localStorage.removeItem("token")
    this._user = null;
  },

  async getUser() {
    try {
      // Send request
      let user = localStorage.getItem("storageUser")

      return {
        isOk: true,
        data: JSON.parse(user)
      };
    }
    catch {
      return {
        isOk: false
      };
    }
  },

  async resetPassword(email) {
    try {
      // Send request

      return {
        isOk: true
      };
    }
    catch {
      return {
        isOk: false,
        message: "Failed to reset password"
      };
    }
  },

  async changePassword(email, recoveryCode) {
    try {
      // Send request


      return {
        isOk: true
      };
    }
    catch {
      return {
        isOk: false,
        message: "Failed to change password"
      }
    }

  },

  async createAccount(email, password) {
    try {
      // Send request


      return {
        isOk: true
      };
    }
    catch {
      return {
        isOk: false,
        message: "Failed to create account"
      };
    }
  }
};
